module.exports = __webpack_public_path__ + "static/media/reactions-icon.ed4380e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reactions-icon.svg
// module id = 829
// module chunks = 0